var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.2 18.4h17.6V20H3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.2 20v-4.8h1.6V20zM19.2 20v-4.8h1.6V20zM3.2 12.8h17.6v1.6H3.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.2 14.4V9.6h1.6v4.8zM19.2 14.4V9.6h1.6v4.8zM12 11.2 8.4 8.008h2.4V3.2A2.4 2.4 0 0 1 13.2.8v7.208h2.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 16,
    r: 0.8,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 10.4,
    r: 0.8,
    fill: "currentColor"
  })));
};
export default SvgSave;